<template>
    <el-card>
        <el-empty description="Sivua ei löytynyt"></el-empty>
    </el-card>
</template>
